<template>
  <div class="container">
    <div class="row align-items-center mt-34">
      <div class="slopePage__title">
        <b>Area fastener grouping</b>
      </div>
    </div>
    <div class="row" v-if="groups.length === 0">
      <div class="slopePage__info">
        <img src="@/assets/img/info-result.svg" alt="info" class="slopePage__info-img">
        <div class="slopePage__info-text">
          <!--@TODO perevod-->
          The fasteners calculation is disabled for this area
        </div>
      </div>
    </div>
    <div class="row" v-if="groups.length !== 0">
      <div class="detailsPage__grouping-scroll">
        <div class="detailsPage__grouping-scroll--swipe wow fadeOut">
          <img src="@/assets/img/swipe.svg" alt="">
        </div>
        <div class="detailsPage__grouping-head"
             :class="{'detailsPage__grouping-head--expanded' : count > 1}">
          <div class="title">№</div>
          <div class="title">Insulation <br>thickness, <br>mm</div>
          <div class="title">Insulation <br>anchor, <br>mm</div>
          <div class="title">Self-tapping <br>screw 4.8x, <br>mm</div>
          <div class="title">Anchor <br>element, <br>mm</div>
          <div class="title">Insulation <br>binding, <br>pc.</div>
          <div class="title" v-if="count > 1">
            <span>Insulation <br>binding, <br>pc.x{{ count }} areas</span>
          </div>
        </div>
        <div class="detailsPage__grouping-body">
          <div class="item" v-for="(item, i) in filteredGroups" :key="item.id"
               :class="{'item--expanded' : count > 1}">
            <div class="item__text"><b><i v-if="i + 1 < 10">0</i>{{ i + 1 }}</b></div>
            <div class="item__text">{{ item.thickness }}</div>
            <div class="item__text">{{ item.fastener }}</div>
            <div class="item__text">{{ item.screw }}</div>
            <div class="item__text">{{ item.ank }}</div>
            <div class="item__text">{{ item.mount }}</div>
            <div class="item__text" v-if="count > 1"><span>{{ item.totalMount }}</span></div>
          </div>
        </div>
      </div>
      <div class="detailsPage__grouping-footer"
           v-if="groups.length > 18"
           @click="isShowRemaining = !isShowRemaining"
           :class="{ active: isShowRemaining }">
        <div v-if="!isShowRemaining" class="detailsPage__grouping-footer-count">
          Show all: {{ groups.length }}
        </div>
        <div v-else class="detailsPage__grouping-footer-count">Hide</div>
        <div class="detailsPage__grouping-footer-arrow">
          <img src="@/assets/img/select-tick-red.svg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    count: Number,
  },
  data() {
    return {
      isShowRemaining: false,
    };
  },
  components: {
  },
  methods: {
  },
  watch: {
  },
  mounted() {
  },
  computed: {
    sortedGroups() {
      return [...this.groups].sort((a, b) => a.thickness - b.thickness);
    },
    filteredGroups() {
      return this.isShowRemaining ? this.sortedGroups : this.sortedGroups.slice(0, 18);
    },
    slopeId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    result() {
      return this.$store.getters.getResult;
    },
    groups() {
      return this.result.sections[this.$route.params.id].fasteners_group;
    },
  },
};
</script>

<style lang="sass" scoped>
.detailsPage
  .mt-34
    margin-top: rem(34)
  .slopePage
    &__title
      +media((font-size: (320: rem(18), 992: rem(24))))
      +media((line-height: (320: rem(26), 992: rem(29))))
      +media((padding-top: (320: rem(11), 992: rem(36))))
      +media((padding-bottom: (320: rem(30), 992: rem(36))))
      // opacity: 0
      // animation-delay: .5s
      // animation-duration: 2.5s
  &__grouping
    &-scroll
      +media((width: (320: auto, 768: 100%)))
      display: flex
      flex-direction: column
      overflow-x: auto
      position: relative
      &--swipe
        +media((display: (320: flex, 768: none)))
        position: absolute
        height: 100%
        background: rgba(0, 0, 0, 0.5)
        flex-direction: row
        align-items: center
        justify-content: center
        width: 100vw
        opacity: 0
        pointer-events: none
        animation-duration: 3s
        img
          width: rem(70)
          animation: swiping 1.5s infinite ease
          position: absolute
          left: 50%
          display: inline-block
    &-head
      display: grid
      grid-template-columns: 2fr 3fr 4fr 3fr 4fr 4fr
      +media((width: (320: 220vw, 360: 200vw, 580: 180vw, 680: 130vw, 768: 120vw, 992: 100%)))
      &--expanded
        grid-template-columns: 2fr 3fr 4fr 3fr 4fr 4fr 4fr
      @extend .common__result-header
      .title
        @extend .common__title-result
        text-align: left
        display: flex
        flex-direction: row
        align-items: center
        padding: rem(19) 0 rem(17)
        &:first-of-type
          padding-left: rem(20)
        span
          color: #999999
        white-space: nowrap
    &-body
      +media((width: (320: 220vw, 360: 200vw, 580: 180vw, 680: 130vw, 768: 120vw, 992: 100%)))
      .item
        background: #FFFFFF
        box-shadow: inset 0 rem(-1) 0 #D6D6D6
        display: grid
        grid-template-columns: 2fr 3fr 4fr 3fr 4fr 4fr
        &--expanded
          grid-template-columns: 2fr 3fr 4fr 3fr 4fr 4fr 4fr
        &__text
          font-style: normal
          font-weight: 500
          line-height: rem(30)
          padding: rem(10) 0
          text-align: left
          +media((font-size: (320: rem(14), 768: rem(16))))
          &:first-of-type
            padding-left: rem(20)
          span
            color: #999999
          i
            font-style: normal
    &-footer
      display: flex
      flex-direction: row
      align-items: center
      justify-content: space-between
      cursor: pointer
      @extend .common__result-footer
      &-count
        @extend .common__result-footer--count
      &-arrow
        @extend .common__result-footer--arrow
      &.active
        .detailsPage__grouping-footer-arrow
          img
            transform: rotate(180deg)
</style>
